import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-to-home',
  templateUrl: './how-to-home.component.html',
  styleUrls: ['./how-to-home.component.css']
})
export class HowToHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
